import React from "react";
import type { DocumentCreationViewProps } from "@ps-bridge/contracts/documentCreation";
import type { DocumentMetadata } from "@ps-bridge/models/core/dataContracts";
import * as styles from "@styles/DocumentCreation.css";

type DocumentCreationSnapshotContractProps = Pick<DocumentCreationViewProps, never>;

type DocumentCreationSnapshotViewProps = DocumentCreationSnapshotContractProps & {
  titleValue: string;
  outlineCount: number;
  styleValue: string;
  selectedSourceDocuments: DocumentMetadata[];
};

const DocumentCreationSnapshotView: React.FC<DocumentCreationSnapshotViewProps> = ({
  titleValue,
  outlineCount,
  styleValue,
  selectedSourceDocuments,
}) => (
  <div className={styles.sideCard}>
    <p className={styles.sideTitle}>Studio snapshot</p>
    <div className={styles.snapshotRow}>
      <span className={styles.snapshotLabel}>Name</span>
      <span className={styles.snapshotValue}>
        {titleValue.trim().length > 0 ? titleValue : "Untitled"}
      </span>
    </div>
    <div className={styles.snapshotRow}>
      <span className={styles.snapshotLabel}>Sections</span>
      <span className={styles.snapshotValue}>{outlineCount} planned</span>
    </div>
    <div className={styles.snapshotPanel}>
      <p className={styles.snapshotTitle}>Intentions summary</p>
      <p className={styles.snapshotText}>
        {styleValue.trim().length > 0
          ? `${styleValue.trim().slice(0, 180)}${
              styleValue.length > 180 ? "…" : ""
            }`
          : "Add a few lines about voice, audience, or constraints to guide the draft."}
      </p>
    </div>
    <div className={styles.snapshotPanel}>
      <p className={styles.snapshotTitle}>Source documents</p>
      <ul className={styles.snapshotSourceList}>
        {selectedSourceDocuments.map((document, index) => (
          <li key={document.id} className={styles.snapshotSourceItem}>
            {index + 1}. {document.name}
          </li>
        ))}
      </ul>
    </div>
  </div>
);

export default DocumentCreationSnapshotView;
